import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    service: [
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/1/out.jpg',
        title: '会议现场接待服务',
        zhTitle: '会议现场接待服务',
        enTitle: 'Meeting site reception service',
        spot: '通过在线培训网络培训大量专业的会议现场服务人员，提供统一标准的接送机、会议签到、用餐及会场管理的服务。确保无论会议在哪里开，均可以给客户提供统一标准的、高质量的、专业的现场服务',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/1/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/1/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/1/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/2/out.jpg',
        title: '活动执行，搭建管理，项目管理',
        zhTitle: '活动执行，搭建管理，项目管理',
        enTitle: 'Activity execution, building management, project management',
        time: '2015年',
        spot: '通过培训专业的公关活动专员，可以负责大型活动项目的搭建管理，控台管理，活动流程管理。或独立负责活动中某一板块的现场管理。',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/2/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/2/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/2/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/3/out.jpg',
        title: '辉瑞小微会议合规抽检工作',
        zhTitle: '辉瑞小微会议合规抽检工作',
        enTitle: 'Pfizer small and micro meeting compliance sampling',
        des: '针对高频次小微会议，进行会议随访及合规抽检服务',
        spot: '接受过专业的合规培训的抽检专员；<br />系统平台自动完成任务派单并将任务通过APP端推送给抽检人员；<br />现场通过check list 方式完成所有随访工作；<br />现场完成所有照片等文件的采集；<br />个性化，标准化的合规抽检报告',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/3/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/3/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/3/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/4/out.jpg',
        title: 'IBM年会',
        zhTitle: 'IBM年会',
        enTitle: 'IBM annual meeting',
        time: '2019年1月',
        number: '100人',
        spot: '年会突出该公司的企业文化以及该公司员工工作中的激情活力。',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/4/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/4/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/4/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/5/out.jpg',
        title: '辉瑞院内培训会',
        zhTitle: '辉瑞院内培训会',
        enTitle: 'Pfizer Hospital Training Conference',
        time: '2018年5月-8月',
        number: '30人',
        spot: '会议执行人、房餐会 项目亮点：标准化及合规化的多场次培训会',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/5/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/5/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/5/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/6/out.jpg',
        title: '康乐保27场城市会',
        zhTitle: '康乐保27场城市会',
        enTitle: 'Kangle Bao 27 City Clubs',
        time: '2018年3月-6月',
        number: '60-80人/场',
        spot: '标准化及合规化的培训会议',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/6/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/6/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/6/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/7/out.jpg',
        title: '康乐保团建',
        zhTitle: '康乐保团建',
        enTitle: 'Construction of Leisure Protection Corps',
        time: '2018年8月',
        number: '60人',
        spot: '团建方案所表达的目的明确，参与人员受益匪浅',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/7/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/7/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/7/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/8/out.jpg',
        title: '鲁南制药PCI短训班',
        zhTitle: '鲁南制药PCI短训班',
        enTitle: 'PCI Short Course for Pharmaceutical Industry in South Shandong',
        time: '2018年10月',
        number: '30人',
        spot: '标准化的会议物料，交通以及现场执行人',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/8/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/8/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/8/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/9/out.jpg',
        title: '路虎上市会',
        zhTitle: '路虎上市会',
        enTitle: 'Land Rover Listing Fair',
        time: '2015年',
        number: '1000人',
        spot: '大规模展会活动现场的流量疏导',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/9/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/9/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/9/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/10/out.jpg',
        title: '强生30城上市会及巡讲会',
        zhTitle: '强生30城上市会及巡讲会',
        enTitle: 'Johnson & Johnson 30 City Listing Fair and Tour Seminar',
        time: '2018年5月-11月',
        number: '50人/场',
        spot: '标准化物料以及掌控整个会议流程。',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/10/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/10/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/10/in3.jpg',
      },
      {
        img: 'https://spkg.smartmice.cn/resources/images/official/training_service/11/out.jpg',
        title: '西安杨森辩论赛',
        zhTitle: '西安杨森辩论赛',
        enTitle: "Xi'an Youngsen Debate Competition",
        time: '2018年11月',
        number: '80人',
        spot: '标准化的会议物料以及现场执行人',
        desImg1: 'https://spkg.smartmice.cn/resources/images/official/training_service/11/in.jpg',
        desImg2: 'https://spkg.smartmice.cn/resources/images/official/training_service/11/in2.jpg',
        desImg3: 'https://spkg.smartmice.cn/resources/images/official/training_service/11/in3.jpg',
      }
    ],
    recruit: [
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/1.jpg",
        title: "出纳",
        email: "HR@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [ 
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "职位月薪：面议",
            "工作地点：北京",
            "发布日期：2019-2-26",
            "工作性质：全职",
            "工作经验：1年",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：出纳"
          ]
        ],
        detail: [
          {
            subTitle: "职位职责：",
            subTxt: [
              "1.按规定每日登记现金日记账。",
              "2.根据记账凭证收付现金。",
              "3.每日负责盘清库存现金，核对现金日记账，按规定程序保管现金，保证库存现金及有价证券安全。",
              "4.保管好各种空白支票、票据、印鉴。",
              "5.负责接收各项银行到款进账凭证，并传递到有关的制单人员。",
              "6.负责代理记账单位出纳工作",
              "7.完成领导交办的其他任务。"
            ]
          },
          {
            subTitle: "任职资格：",
            subTxt: [
              "1.会计、财务等相关专业中专以上学历，有会计从业资格证书，1年以上工作经验；",
              "2.了解国家财经政策和会计、税务法规，熟悉银行结算业务；",
              "3.熟练使用各种财务工具和办公软件，且电脑操作娴熟，有较强的责任心，有良好的职业操守，作风严谨；",
              "4.善于处理流程性事务、良好的学习能力、独立工作能力和财务分析能力；",
              "5.工作细致，责任感强，良好的沟通能力、团队精神。"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "HR@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/2.jpg",
        title: "会计（京籍优先）",
        email: "HR@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "带薪病假",
            "职位月薪：4k-6k",
            "工作地点：北京",
            "发布日期：2019-2-26",
            "工作性质：全职",
            "工作经验：3-4年",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：会计"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1. 负责公司日常费用的核算、分摊、录入等；",
              "2. 负责相关财务报表编制；",
              "3. 负责公司的统计工作；",
              "4. 负责银行、现金的盘点、核对；编制盘点表和余额调节表，并存档。",
              "5. 负责报税：集团公司及个人纳税申报；",
              "6. 负责固定资产管理；",
              "7. 负责发票购买、专票增版增量及票据认证；",
              "8.完成上级安排的其它工作。",
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.本市户口优先，会计相关专业，专科以上学历，有会计上岗证。",
              "2.2年以上工作经验。",
              "3.有旅游行业工作经验者优先。",
              "4.认真细致，爱岗敬业，吃苦耐劳，有良好的职业操守，有良好的沟通能力。"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "HR@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/3.jpg",
        title: "会议专员（操作/计调/OP）",
        email: "HR@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "带薪病假",
            "职位月薪：5k-8k",
            "工作地点：北京",
            "发布日期：2018-5-15",
            "工作性质：全职",
            "工作经验：2年",
            "最低学历：大专",
            "招聘人数：2人",
            "职位类别：会议专员"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.与客户沟通，以专业角度快速、准确理解客户提出的会议需求；",
              "2.负责交通，机票、酒店的报价、预订、采购等相关事宜；",
              "3.负责与客户及供应商沟通需求及预订等事宜；",
              "4.完成领导交办的其他任务。",
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.相关行业经验1年以上。热爱旅游行业，有较强的服务意识和良好的服务态度，有耐心，能够主动、积极的为客户提供服务。",
              "2.熟练掌握计算机基础操作和日常办公软件使用。",
              "3.有较强的学习能力，认真勤奋。",
              "4.具有良好团队协作精神，能服从公司各项管理规定及工作安排。",
              "5.具有良好的沟通能力和严谨细致的工作作风。",
              "6.认同公司企业文化，有长期发展目标，将个人成长与公司发展结合起来。",
              "7.有《会议执行专员》岗位能力证书的优先录取。"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层",
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "HR@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/4.jpg",
        title: "供应商管理主管",
        email: "HR@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "带薪病假",
            "职位月薪：6k-8k",
            "工作地点：北京",
            "发布日期：2018-10-30",
            "工作性质：全职",
            "工作经验：2年",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：供应商管理主管"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.建立供应商管理机制，处理并推动日常问题解决，不断优化与完善管理工作。",
              "2.根据客户要求，达成SOP中约定的指标。",
              "3.对接客户，负责资源方面的相关问题处理，整改和预防，并推动解决系统问题，满足客户方的合理需求。"
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.具备2年以上团队管理经验",
              "2.有互联网行业餐品类的运营经验或客服中心服务类型项目管理经验者优先考虑。"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "HR@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/5.jpg",
        title: "AE客户执行/活动执行",
        email: "demi.hu@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "带薪病假",
            "职位月薪：4.5k-6k",
            "工作地点：北京",
            "发布日期：2019-3-12",
            "工作性质：全职",
            "工作经验：1年",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：活动执行专员"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.与客户进行良好沟通，跟踪、了解客户的需求，并将客户需求完整有效的传递给公司；",
              "2.负责与客户沟通日常执行工作相关并落实，监督每一个项目在执行期内每天的具体进程，执行工作有突发情况及时处理并汇报；",
              "3.能独立或协助客主管完成项目策划及广告排期制定；据客户账期，督促客户完成回款流程",
              "4.服从并监督执行公司业务流程 ；负责客户项目的总结、归档，内部资料的整理归纳",
              "5.维护客户关系，致力于提高客户满意度；"
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.本科以上学历，广告、设计、市场营销、医学、药学、化学等专业等优先；",
              "2.热爱广告，有一年以上AE岗位以及项目执行工作经验优先；",
              "3.具备广告专业知识，有一定的策略、策划和文字表达能力，熟悉客户服务的各个环节；",
              "4.性格开朗，具有较好的语言表达能力、沟通能力及应变能力，逻辑性和统筹能力强；",
              "5.有责任心、进取心，工作态度端正、积极，有良好的团队合作精神，能承受较大的工作压力；",
              "​6.具备良好的工作计划性和执行力，能熟练运用EXCEL，PPT，PS等OFFICE软件。",
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层",
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "demi.hu@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/6.jpg",
        title: "财务部（实习生）",
        email: "HR@smartmice.cn",
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "商业保险",
            "节日福利",
            "周末双休",
            "职位月薪：2k-3k",
            "工作地点：北京",
            "发布日期：2019-2-26",
            "工作性质：实习",
            "工作经验：不限",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：实习生"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "安排在 财务部培训实习",
              "公司没有宿舍，所以只接受在京有居住地的实习生。"
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1、专科或以上财会专业在校生，应届生",
              "2、在公司实习期半年，期满部门考评通过后可以聘用为公司正式员工"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "北京市朝阳区广渠东路3号中水电国际大厦5层"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "HR@smartmice.cn"
            ]
          }
        ]
      },
      // {
      //   img: "https://spkg.smartmice.cn/resources/images/official/recruit/7.jpg",
      //   title: ".net高级后端开发工程师",
      //   email: 'demi.hu@smartmice.cn',
      //   children: [
      //     ["中智商展（北京）国际会议展览股份公司"],
      //     [ 
      //       "五险一金",
      //       "绩效奖金",
      //       "带薪年假",
      //       "补充医疗保险",
      //       "定期体检",
      //       "节日福利",
      //       "带薪病假",
      //       "职位月薪：10k-20k",
      //       "工作地点：四川",
      //       "发布日期：2019-2-15",
      //       "工作性质：全职",
      //       "工作经验：3-4年",
      //       "最低学历：大专",
      //       "人数：1人",
      //       "职位类别：软件研发工程师"
      //     ]
      //   ],
      //   detail: [
      //     {
      //       subTitle: "岗位职责：",
      //       subTxt: [
      //         "1.负责现网MyAQL、MongoDB、Redis等数据库系统的稳定、高效、安全运行；",
      //         "2负责数据库总体设计，根据业务场景，选择合适的数据存储；",
      //         "3.梳理业务流程和数据模型，对数据模型进行建议和把关；",
      //         "4.配合开发部门做好项目上线、重构、数据迁移等工作，定期分享和培训。"
      //       ]
      //     },
      //     {
      //       subTitle: "任职要求：",
      //       subTxt: [
      //         "1.熟悉微服务开发模式、精通.netcore，了解JAVA优先",
      //         "2.熟悉MySQL体系结构，对InnoDB存储引擎有深入理解；",
      //         "3.具有丰富的SQL优化经验，较强故障定位和处理能力；",
      //         "4.熟悉MySQL数据库分库分表策略，数据迁移方案，具备互联网大型数据库高并发量设计经验；",
      //         "5.除MySQL外，熟悉Redis/MongoDB/Hbase/ES等至少一种nosql或分布式存储的使用和管理经验；",
      //         "6.熟悉MySQL与NoSQL常用高可用、集群方案；",
      //         "7.工作认真谨慎，具有良好的沟通能力和团队协作能力；",
      //         "8.熟悉阿里云/腾讯云数据库产品优先，熟悉Gelera/MaxScale/ProxySQL中间件优先，具备Python/Go/Java等开发经验优先。"
      //       ]
      //     },
      //     {
      //       subTitle: "工作地点：",
      //       subTxt: [
      //         "四川省成都市武侯区蜀锦路88号楚峰国际中心1202A"
      //       ]
      //     },
      //     {
      //       subTitle: "投递邮箱：",
      //       subTxt: [
      //         "demi.hu@smartmice.cn"
      //       ]
      //     }
      //   ]
      // },
      // {
      //   img: "https://spkg.smartmice.cn/resources/images/official/recruit/8.jpg",
      //   title: "ERP高级整合研发工程师",
      //   email: 'demi.hu@smartmice.cn',
      //   children: [
      //     ["中智商展（北京）国际会议展览股份公司"],
      //     [
      //       "五险一金", 
      //       "绩效奖金", 
      //       "带薪年假", 
      //       "补充医疗保险", 
      //       "定期体检", 
      //       "节日福利", 
      //       "带薪病假",
      //       "职位月薪：10k-15k",
      //       "工作地点：成都",
      //       "发布日期：2019-2-12",
      //       "工作性质：全职",
      //       "工作经验：3-4年",
      //       "最低学历：大专",
      //       "招聘人数：1人",
      //       "职位类别：软件研发工程师"
      //     ]
      //   ],
      //   detail: [
      //     {
      //       subTitle: "岗位职责：",
      //       subTxt: [
      //         "1.参与公司ERP系统日常维护、开发",
      //         "2.参与公司ERP新整合设计、开发"
      //       ]
      //     },
      //     {
      //       subTitle: "任职要求：",
      //       subTxt: [
      //         "1.3年以上.NET开发经验、精通.NET框架相关知识，精通C#语言",
      //         "2.精通SQL SERVER或MySql",
      //         "3.有ERP开发实施、熟悉用友U8产品背景优先",
      //       ]
      //     },
      //     {
      //       subTitle: "工作地址：",
      //       subTxt: [
      //         "四川省成都市武侯区蜀锦路88号楚峰国际中心1202A"
      //       ]
      //     },
      //     {
      //       subTitle: "投递邮箱：",
      //       subTxt: [
      //         "demi.hu@smartmice.cn"
      //       ]
      //     }
      //   ]
      // },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/9.jpg",
        title: "合规专员",
        email: 'demi.hu@smartmice.cn',
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "职位月薪：4.5k-6k" ,      
            "工作地点：上海",
            "发布日期：2019-3-11",
            "发布日期：2016-09-25",
            "工作性质：全职",
            "工作经验：不限",
            "最低学历：大专",
            "招聘人数：2人",
            "职位类别：合规专员"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.对业务人员上交的结算文件按照合规要求进行严格细致的审查（审查包括：材料是否齐全、发票真伪验证等）以及对问题结算材料的处理；",
              "2.结算文件管理：归档、扫描、递送；",
              "3.定期参加客户组织的培训，更新客户对结算文件的要求；",
              "4.按照客户要求每月每季度提交统计表，配合进行审计等相关工作；",
              "5.领导安排的其它工作。"
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.了解旅游或会展行业；",
              "2.工作积极主动，耐心细致，有责任心；",
              "3.有一定会议管理或财务经验者优先考虑；"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "上海市普陀区澳门路158号纺博大厦604室"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "demi.hu@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/10.jpg",
        title: "会议助理（实习）",
        email: 'demi.hu@smartmice.cn',
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "商业保险",
            "节日福利",
            "周末双休",
            "职位月薪：2k-3k",
            "工作地点：上海",
            "发布日期：2019-3-11",
            "工作性质：实习",
            "工作经验：不限",
            "最低学历：大专",
            "招聘人数：3人",
            "职位类别：实习生"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.协助部门人员进行大型团队资料整理、客户联络、文档处理等工作；",
              "2.在指导下完成活动方案制订以及客户沟通；" 
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.会展、旅游管理、工商管理、市场营销、文秘、电子商务等相关专业优先；",
              "2.对会展旅游等业务有一定了解，热爱并愿意从事本职业，希望与企业共成长。",
              "3.熟练操作办公软件及设备；",
              "4.有较强的沟通和协调能力，具有发现问题的敏锐洞察力及应变能力；",
              "5.为人诚恳、有责任心，稳定性强，踏实肯干，吃苦耐劳，工作愿意服从安排。"
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "上海市普陀区澳门路158号纺博大厦604室"
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "demi.hu@smartmice.cn"
            ]
          }
        ]
      },
      {
        img: "https://spkg.smartmice.cn/resources/images/official/recruit/5.jpg",
        title: "AE客户执行/活动执行",
        email: 'demi.hu@smartmice.cn',
        children: [
          ["中智商展（北京）国际会议展览股份公司"],
          [
            "五险一金",
            "绩效奖金",
            "带薪年假",
            "补充医疗保险",
            "定期体检",
            "节日福利",
            "带薪病假",
            "职位月薪：4.5k-6k",
            "工作地点：上海",
            "发布日期：2019-3-12",
            "工作性质：全职",
            "工作经验：1年",
            "最低学历：大专",
            "招聘人数：1人",
            "职位类别：活动执行专员"
          ]
        ],
        detail: [
          {
            subTitle: "岗位职责：",
            subTxt: [
              "1.与客户进行良好沟通，跟踪、了解客户的需求，并将客户需求完整有效的传递给公司；",
              "2.负责与客户沟通日常执行工作相关并落实，监督每一个项目在执行期内每天的具体进程，执行工作有突发情况及时处理并汇报；",
              "3.能独立或协助客主管完成项目策划及广告排期制定；据客户账期，督促客户完成回款流程",
              "4.服从并监督执行公司业务流程 ；负责客户项目的总结、归档，内部资料的整理归纳",
              "5.维护客户关系，致力于提高客户满意度；"
            ]
          },
          {
            subTitle: "任职要求：",
            subTxt: [
              "1.本科以上学历，广告、设计、市场营销、医学、药学、化学等专业等优先；",
              "2.热爱广告，有一年以上AE岗位以及项目执行工作经验优先；",
              "3.具备广告专业知识，有一定的策略、策划和文字表达能力，熟悉客户服务的各个环节；",
              "4.性格开朗，具有较好的语言表达能力、沟通能力及应变能力，逻辑性和统筹能力强；",
              "5.有责任心、进取心，工作态度端正、积极，有良好的团队合作精神，能承受较大的工作压力；",
              "​6.具备良好的工作计划性和执行力，能熟练运用EXCEL，PPT，PS等OFFICE软件。",
            ]
          },
          {
            subTitle: "工作地点：",
            subTxt: [
              "上海市普陀区澳门路158号纺博大厦604室",
            ]
          },
          {
            subTitle: "投递邮箱：",
            subTxt: [
              "demi.hu@smartmice.cn"
            ]
          }
        ]
      }
    ]
  },
  mutations: {
    setValue(state, value) {
      for (var key in value) {
        state[key] = value[key];
      }
    }
  },
  actions: {

  }
})